import errorLink from "@/vue-apollo/links/error";
import {
  createHttpLink,
  InMemoryCache,
  from,
  split,
} from "@apollo/client/core";
import { createPersistedQueryLink } from "@apollo/client/link/persisted-queries";
import { sha256 } from 'crypto-hash';
import { getMainDefinition } from "@apollo/client/utilities";
import createWsLink from "@/vue-apollo/links/ws";
import authLink from "@/vue-apollo/links/auth";


const v2HttpLink = createHttpLink({
  uri: process.env.VUE_APP_GRAPHQL_HTTP_V2
  // || "http://localhost:3000/graphql"
  || "https://api.compass.art/graphql",
  useGETForQueries: true,
});

const persistedQueriesLink = createPersistedQueryLink({ sha256 });
const wsEndpoint = process.env.VUE_APP_GRAPHQL_WS_V2 || 'wss://api.compass.art/graphql-socket'

const wsLink = createWsLink({ wsEndpoint });

const v2ClientOptions = {
  name: "web",

  version: process.env.VUE_APP_VERSION,

  link: from([
    errorLink,

    split(
      ({ query }) => {
        const { kind, operation } = getMainDefinition(query);
        return kind === "OperationDefinition" && operation === "subscription";
      },

      wsLink,

      from([
        authLink,
        persistedQueriesLink,
        v2HttpLink
      ])
    ),
  ]),

  cache: new InMemoryCache({
    possibleTypes: {
      Prize: ["TokenPrize", "WhitelistCollectionPrize"],
    },
    typePolicies: {
      Collection: {
        merge(existing, incoming) {
          if (!incoming && existing) {
            return existing;
          }
          return incoming;
        },
        fields: {
          listingEvents: {
            merge(_, incoming) {
              return incoming;
            }
          },
          transactionsChart: {
            merge(existing, incoming) {
              if (!incoming && existing) {
                return existing;
              }
              return incoming;
            }
          }
        }
      },
      CollectionCharts: {
        merge: true,
      },
      Subscription: {
        fields: {
          collectionListingsFeed: {
            merge(existing, incoming) {
              return incoming;
            }
          }
        }
      }
    }
  }),

  defaultOptions: {
    query: {
      errorPolicy: "all",
    },

    watchQuery: {
      errorPolicy: "all",
    },

    mutate: {
      errorPolicy: "all",
    }
  }
};

export default v2ClientOptions;
